import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeviceEnum } from '../../core';
import { IPlanControl } from '../../models';
import { PlanFormService } from '../../services';
import { BaseComponent } from '../../shared';
import { PlanBoneComponent } from '../plan-bone';
import { PlanImageComponent } from '../plan-image';


/**
 * Plan setup section component.
 */
@Component({
	selector: 'plan-setup',
	templateUrl: './plan-setup.component.html',
	imports: [
		FormsModule,
		PlanBoneComponent,
		PlanImageComponent,
		ReactiveFormsModule
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PlanSetupComponent extends BaseComponent implements OnInit {

	private readonly planFormSrv = inject(PlanFormService);

	form?: FormGroup<IPlanControl>;
	isReadonly = false;

	get isFormVisible(): boolean { return !!this.form; };
	get isSetupVisible(): boolean { return this.form?.value.device === DeviceEnum.Tlhex; };
	get setupValue(): boolean | null { return this.form?.value.withImages as boolean | null; };


	ngOnInit(): void {
		this.planFormSrv.getForm().subscribe(form => {
			this.form = form;
			this.isReadonly = this.planFormSrv.isReadonly;
		});
	}

}
